import { render, staticRenderFns } from "./lay-container.vue?vue&type=template&id=a33591e6&scoped=true"
import script from "./lay-container.vue?vue&type=script&lang=js"
export * from "./lay-container.vue?vue&type=script&lang=js"
import style0 from "./lay-container.vue?vue&type=style&index=0&id=a33591e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33591e6",
  null
  
)

export default component.exports